import {UserSummary} from './userSummary.model';
import {UserAccountSummaryModel} from './userAccountSummary.model';
import {AccountSummary} from '../../../../../../shared/model/account/accountSummary.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';
import {UserAccountModel} from './userAccount.model';

export class User {
    summary: UserSummary;
    accounts: UserAccountModel[] = [];
    picture: DocumentSummaryModel;
    permissionValues: string[] = [];

    private getUserAccountByAccountBusinessCodeAndAccounts(accountBusinessCode: string,
                                                           accounts: UserAccountSummaryModel[]): UserAccountSummaryModel {
        const matchingAccounts = accounts?.filter(value => value.account.businessCode === accountBusinessCode);
        return matchingAccounts?.length > 0 ? matchingAccounts[0] : undefined;
    }

    get defaultAccount(): AccountSummary {
        const accounts = this.accounts?.filter(value => value.summary.defaultAccount === true)
            .map(value => value.summary.account);
        return accounts?.length > 0 ? accounts[0] : undefined;
    }
}
